// extracted by mini-css-extract-plugin
export default {"code":"b533c3f9e2ab"};